import { injectable } from 'inversify';

import type { FlowTreeNode, LinearFlowNode } from '@vk-hr-tek/ui/FlowTree';

import { EventFlow } from '@app/gen/events';

import { VacationsFlowMapper } from '../../types';

import { VacationsFlowCommonMapper } from './vacations.flow-common.mapper';
import { VacationsFlowMapper as EventsFlowTreeMapper } from './vacations.flow.mapper.worker';
import { VacationsLinearFlowMapper } from './vacations.linear-flow.mapper';

const commonMapper = new VacationsFlowCommonMapper();
const flowMapper = new EventsFlowTreeMapper(commonMapper);
const linearMapper = new VacationsLinearFlowMapper(commonMapper);

@injectable()
export class VacationsThreadFlowMapper implements VacationsFlowMapper {
  async convertTree(flow: EventFlow): Promise<FlowTreeNode> {
    flowMapper.init(flow.nodes, flow.in_paper);

    const result = flowMapper.getFlowTree(flow.start_node_id);

    return result as FlowTreeNode;
  }

  async convertLinear(flow: EventFlow): Promise<LinearFlowNode[]> {
    linearMapper.init(flow.nodes);

    const result = linearMapper.getLinearFlowTree(flow.start_node_id);

    return result;
  }
}
